import React from 'react';

import Modal from './../shared/Modal';
import Button from './../shared/Button';
import { VERSION } from './../../constants/version';
import { SUBJECT_TYPES } from './../../constants/subjectTypes';

const FINISH_MODAL_VERSION = [
  VERSION.v4,
  VERSION.v5,
  VERSION.v6,
  VERSION.v7,
  VERSION.v8,
  VERSION.v9,
]

const FinishModal = props => {
  const { onStartEssay, isUSA, version, subjectType } = props;

  if (subjectType.indexOf(Object.values(SUBJECT_TYPES)) > -1) {
    const sum = isUSA ? '$10' : '$5';
    return(
      <Modal isWide>
        <h1>Welcome to our final <b>testing stage!</b></h1>
        <p>You've entered the last stage that checks your skills and performance! After you went through short tests and tutorials we want to make sure you are ready to complete orders. Show us what you've learned!</p>
        <p>Our recruiting Managers will check your progress and scores earned in our testing environment and get back you within the next 3-5 business days with the feedback. Note that the task you are to complete is a <b>test task</b> which is <b>exceptionally used to check your knowledge and skills.</b> </p>
        <p>To keep you motivated, a <b>{sum} welcome bonus</b> will be added right to your available balance if you <b>successfully completed two tests and the test task meets the key requirements.</b> Can’t wait to see you joining us! Good luck!</p>
        <Button onClick={onStartEssay} block>Make the final step</Button>
      </Modal>
    )
  }

  if (version.indexOf(FINISH_MODAL_VERSION) > -1) {
    const sumStart = isUSA ? '$16' : '$8';
    const sumEnd = isUSA ? '$28' : '$14';
    const sum = isUSA ? '$55' : '$30';
    return (
      <Modal isWide>
        <h1>Congratulations! Now you know how to nail it!</h1>
        <p>You’ve entered the last stage in our testing environment that presupposes the completion of 2 small tasks of your choice. Once the tasks are successfully completed and you are hired, an <b>onboarding bonus</b> will be added right to your financial balance!  </p>
        <p>The amount of your onboarding bonus depends on the subjects you complete your test assignments in and varies from <b>{sumStart} to {sumEnd}</b>. You will be able to withdraw these funds once you have {sum} on your available balance.</p>
        <p>We suggest a variety of tasks, from academic essays in humanitarian fields to problem-solving and calculations in technical-related subjects! We will check your papers and provide our feedback, so you know your areas for improvement.</p>
        <p>Please note that <b>none of your submitted tasks are used for any purposes except for checking your knowledge in the subjects of your choice.</b></p>
        <Button onClick={onStartEssay} block>Begin the first task</Button>
      </Modal>
    );
  }

  const sum = isUSA ? '$20' : '$10';
  return (
    <Modal isWide>
      <h1>Welcome to our <b>testing environment!</b></h1>
      <p>You’ve entered the last but not least stage of checking your performance. Paper quality is our top priority and we want to make sure you are ready to complete academic papers before entering the platform with real orders.</p>
      <p>On this testing platform you are to complete two orders in any subjects that you like (either HASS or STEM). We will thoroughly check your papers and provide you with detailed feedback, so you can see your area of improvement. <b>None of them are used for any purposes except for checking your knowledge and writing skills.</b> </p>
      <p>To keep you motivated, a <b>{sum} bonus</b> is added upon the successful completion of two orders. After that you are redirected to our platform with real orders and our rewarding cooperation begins.</p>
      <Button onClick={onStartEssay} block>Begin the first essay</Button>
    </Modal>
  );
};

export default FinishModal;



// WEBPACK FOOTER //
// ./src/components/AcademicTest/FinishModal.js